module.exports = __webpack_public_path__ + "img/symbol_1.69f519a9.png";